import axios from 'axios';
import aesReduxConstants from '../constants';
import notificationsSelectors from '../selectors/notificationsSelectors';
import contextSelectors from '../selectors/contextSelectors';
import API_HOST from '../api';

const notificationActions = function() {
  const factory = {};
  const api = {};
  const constants = aesReduxConstants;

  api.getNotifications = function(clientId, userId, limit, offset) {
    const url = `${API_HOST}/api/client/${clientId}/user/${userId}/notification-list?limit=${limit}&offset=${offset}`;
    return axios.get(url)
      .then((response) => {
        const notifications = response.data.notificationList;

        return { notifications, unreadCount: response.data.unreadCount };
      }, (error) => {
        alert('There was an error requesting your notifications');
        return error;
      });
  };

  /**
   * Get Notifications Success
   * replaces the notification list with an array of notificiations. Usually used inside of `getNotificationsAction`
   */
  factory.getNotificationsSuccess = function(notifications, unreadCount) {
    return {
      type: constants.GET_NOTIFICATIONS_SUCCESS,
      notifications,
      unreadCount,
    };
  };

  factory.appendNotification = function(notification) {
    return {
      type: constants.APPEND_NOTIFICATION,
      notification,
    };
  };

  factory.replaceNotification = function(notification) {
    return {
      type: constants.REPLACE_NOTIFICATION,
      notification,
    };
  };

  factory.setAllAsRead = function(timestamp) {
    return {
      type: constants.SET_ALL_AS_READ,
      timestamp,
    };
  };

  /**
   * Get Notifications
   * sends a request to get notifications and updates the list with the notifications from the api response
   */
  factory.getNotifications = function(append, page) {
    return function(dispatch, getState) {
      const state = getState();
      const requestForPage = page == undefined ? notificationsSelectors.selectCurrentPage(state) : page;

      // no context switching supported with notifications
      const userId = contextSelectors.selectUserId(state);
      const clientId = contextSelectors.selectClientId(state);

      dispatch({ type: constants.GET_NOTIFICATIONS });
      api.getNotifications(clientId, userId, 10, requestForPage)
        .then((notifications) => {
          // success, update the notifications list
          dispatch(factory.getNotificationsSuccess(notifications.notifications, notifications.unreadCount));
        });
    };
  };

  return factory;
};

export default notificationActions();
